interface FiltersProps {
    filter: string | null;
    setFilter: (n: string) => void;
}
export default function SearchFilter({ filter, setFilter }: FiltersProps) {

    const clear = () => {
        setFilter('');
        window.history.replaceState(null, '', '/annuaire');
    };

    return (
        <div className="filter">
            <label className='text-gray-600'>Rechercher :</label>
            <div className="relative">
                <input placeholder="Nom, ville" className="border border-gray-100 bg-white rounded-lg px-2 py-1" value={filter || ""} onChange={e => setFilter(e.target.value)} />
                <a role="button" onClick={clear} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </a>
            </div>
        </div>
    );
};